import { render, staticRenderFns } from "./CancellationTrends.vue?vue&type=template&id=098f5f76&"
import script from "./CancellationTrends.vue?vue&type=script&lang=ts&"
export * from "./CancellationTrends.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports